import { render, staticRenderFns } from "./RecordRevisionsSettings.vue?vue&type=template&id=050e365e&"
import script from "./RecordRevisionsSettings.vue?vue&type=script&lang=js&"
export * from "./RecordRevisionsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports